import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ResourceForm } from '@lib/resource-form';
import { ResourceTable } from '@lib/resource-table';
import { Auth, ResourcesService } from 'src/app/service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    ResourceTable,
    MatDialogModule,
  ],
  template: `
    <mat-toolbar>
      <h1>Resources</h1>
      <span class="spacer"></span>
      <div class="cell-actions">
        @if (auth.isAdmin()) {
          <button matMiniFab matTooltip="Add Resource" (click)="showForm()">
            <mat-icon>add</mat-icon>
          </button>
        }
        <button matIconButton (click)="reload()">
          <mat-icon [class.rotating]="pending()">refresh</mat-icon>
        </button>
      </div>
    </mat-toolbar>

    <section>
      <div class="body">
        <lcm-resource-table [resources]="resources()" [pending]="pending()" (edited)="reload()" (removed)="reload()" />
      </div>
    </section>
  `,
})
export class ResourcesPage {
  private dialog = inject(MatDialog);
  auth = inject(Auth);

  private resourceService = inject(ResourcesService);

  resources = this.resourceService.resources;

  pending = this.resourceService.pending;

  reload() {
    this.resourceService.reload();
  }

  showForm() {
    this.dialog
      .open(ResourceForm)
      .afterClosed()
      .subscribe({ next: (result) => result && this.reload() });
  }
}
